import { render, staticRenderFns } from "./similar.vue?vue&type=template&id=69ea5050&"
import script from "./similar.vue?vue&type=script&lang=ts&"
export * from "./similar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports